// Literal case-insensitive matches use the original string so Unicode case
// expansion cannot change source offsets. Matches never overlap.
export function findTranscriptMatches(text, query) {
  if (typeof text !== 'string' || !query) return [];
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return Array.from(text.matchAll(new RegExp(escaped, 'giu')), (match) => ({
    start: match.index,
    end: match.index + match[0].length,
  }));
}

export function buildTranscriptParagraphs(text) {
  if (typeof text !== 'string' || !text) return [];
  const ranges = [];
  let start = 0;
  let sentences = 0;
  const boundaries = /\n\s*\n|[.!?](?:["'”’])?\s+/g;
  Array.from(text.matchAll(boundaries)).forEach((match) => {
    sentences += 1;
    if (match[0].includes('\n') || sentences >= 4) {
      const end = match.index + match[0].length;
      ranges.push({ start, end });
      start = end;
      sentences = 0;
    }
  });
  if (start < text.length) ranges.push({ start, end: text.length });
  return ranges;
}
